import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Button,
    useTheme
} from '@mui/material';
import { ConfirmDialogProps } from '../types/interfaces';

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
    title,
    message,
    onConfirm,
    onCancel,
}) => {
    const theme = useTheme();

    return (
        <Dialog
            open
            onClose={onCancel}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: {
                    backgroundColor: theme.palette.background.paper,
                    color: theme.palette.text.primary,
                },
            }}
        >
            <DialogTitle>{title}</DialogTitle>

            <DialogContent>
                <Typography>{message}</Typography>
            </DialogContent>

            <DialogActions>
                {onCancel && (
                    <Button onClick={onCancel} color="secondary">
                        Cancel
                    </Button>
                )}
                {onConfirm && (
                    <Button onClick={onConfirm} variant="contained" color="primary">
                        Confirm
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;
